import SyIcon from "./sy-icon";

export default SyIcon